import tag from '@/js/util/props/tag'
import animationWrapper from '@/js/util/symbols/animationWrapper'

export default {
  provide() {
    return { [animationWrapper]: this }
  },
  props: {
    ...tag,

    replay: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      previousIsIntersecting: undefined,
    }
  },

  methods: {
    handleCallback({ isIntersecting }) {
      const { previousIsIntersecting, replay } = this
      if (previousIsIntersecting === undefined && replay) {
        this.previousIsIntersecting = isIntersecting
        return
      }
      if (isIntersecting === previousIsIntersecting) {
        return
      }
      if (!replay && !isIntersecting) {
        return
      }
      this.previousIsIntersecting = isIntersecting
    },
  },

  render(createElement) {
    const props = { tag: this.tag, callback: this.handleCallback }
    return createElement('BaseIntersection', { props }, this.$slots.default)
  },
}



// WEBPACK FOOTER //
// ./src/js/components/BaseAnimation.js